var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcNotAvailableMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 32,
    viewBox: "0 0 69 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65234 21H7.63574L2.74121 13.0225H2.67969C2.69792 13.2913 2.71387 13.5762 2.72754 13.877C2.74577 14.1777 2.75944 14.4876 2.76855 14.8066C2.78223 15.1257 2.79362 15.4492 2.80273 15.7773V21H1.3125V11.0059H3.31543L8.20312 18.9287H8.25098C8.24186 18.6963 8.23047 18.4297 8.2168 18.1289C8.20312 17.8281 8.18945 17.5182 8.17578 17.1992C8.16667 16.8757 8.15983 16.5635 8.15527 16.2627V11.0059H9.65234V21ZM16.3174 11.0059L12.5918 21H11.0879L14.8135 11.0059H16.3174ZM23.9395 21L22.9619 18.2246H19.1406L18.1631 21H16.4336L20.1523 10.9648H21.9707L25.6826 21H23.9395ZM22.5381 16.8164L21.5879 14.082C21.5514 13.9635 21.499 13.7972 21.4307 13.583C21.3623 13.3643 21.2939 13.1432 21.2256 12.9199C21.1572 12.6921 21.1003 12.5007 21.0547 12.3457C21.0091 12.5326 20.9521 12.7422 20.8838 12.9746C20.82 13.2025 20.7562 13.4167 20.6924 13.6172C20.6331 13.8177 20.5876 13.9727 20.5557 14.082L19.5986 16.8164H22.5381Z",
    fill: "#878B97"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1037_152233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 0,
    width: 37,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 36.8,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1037_152233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8751 24.0069C31.5548 19.8802 31.7332 15.42 33.3787 11.4119L39.3362 13.8577C38.2666 16.463 38.1507 19.3622 39.0089 22.0445L32.8751 24.0069Z",
    fill: "#EA5532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6782 18.4C53.6782 20.1673 52.2455 21.6 50.4782 21.6C49.611 21.6 48.8243 21.255 48.248 20.6948L41.3578 19.1015C40.6141 18.9295 40.6141 17.8705 41.3578 17.6985L48.248 16.1052C48.8243 15.545 49.611 15.2 50.4782 15.2C52.2455 15.2 53.6782 16.6327 53.6782 18.4Z",
    fill: "#DDDFE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8749 24.0061C31.9928 21.2486 31.7738 18.3217 32.2359 15.4636C32.6979 12.6055 33.8279 9.8967 35.534 7.55752C37.24 5.21834 39.474 3.31477 42.0543 2.00157C44.6346 0.688364 47.4884 0.00259404 50.3836 7.3436e-06C53.2788 -0.00257935 56.1338 0.678091 58.7165 1.98668C61.2991 3.29527 63.5365 5.19484 65.2467 7.53097C66.957 9.8671 68.0918 12.5738 68.559 15.4311C69.0261 18.2884 68.8124 21.2157 67.9352 23.9748L61.7979 22.0236C62.3681 20.2302 62.507 18.3275 62.2033 16.4702C61.8997 14.613 61.1621 12.8536 60.0504 11.3351C58.9387 9.81665 57.4844 8.58193 55.8057 7.73134C54.127 6.88076 52.2713 6.43832 50.3894 6.44001C48.5075 6.44169 46.6525 6.88744 44.9753 7.74102C43.2981 8.5946 41.846 9.83192 40.7371 11.3524C39.6282 12.8729 38.8937 14.6335 38.5933 16.4913C38.293 18.3491 38.4353 20.2516 39.0087 22.044L32.8749 24.0061Z",
    fill: "#DDDFE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcNotAvailableMd);
export default __webpack_public_path__ + "static/media/edcNotAvailable-md.a1d283f40e501bad2430edc9d449138e.svg";
export { ForwardRef as ReactComponent };